import { render } from "./userLogin.vue?vue&type=template&id=07019981&scoped=true"
import script from "./userLogin.vue?vue&type=script&lang=js"
export * from "./userLogin.vue?vue&type=script&lang=js"

import "./userLogin.vue?vue&type=style&index=0&id=07019981&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07019981"]])

export default __exports__